import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const ACCORDION_TYPE = 'accordion';

@injectable()
export class AccordionItemsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.accordion', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(ACCORDION_TYPE, $element.attr('id'));
      const title: string = $element.attr('data-title') || 'accordion-component';

      const items: { [id: string]: boolean } = {};
      $('.reveal-list-content', $element).each((itemIndex: number) => {
        const itemId: string = this.sectionProgressUtils.createItemId(id, itemIndex);
        items[itemId] = false;
      });

      interactions = [...interactions, {
        id,
        title,
        type: ACCORDION_TYPE,
        completed: false,
        items
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === ACCORDION_TYPE) {
      const accordionId: string = interaction.id;
      const itemId: string = this.sectionProgressUtils.createItemId(accordionId, interaction.index);
      completion = this.sectionProgressUtils.setInteractionItemCompleted(
        completion,
        accordionId,
        ACCORDION_TYPE,
        itemId
      );
    }

    return completion;
  }
}
